<template>
    <div id="tickets-page" :class="{ 'is-detail-open': hasTicketId }">
        <div class="columns">
            <div class="column" :class="toggle ? 'is-6-desktop' : ''">
                <Tickets/>
            </div>
            <div class="column" :class="toggle ? 'is-6-desktop' : 'is-0'">
                <b-button
                    v-if="hasTicketId"
                    class="ticket-panel-toggle crm-action-icon"
                    data-tooltip="CERRAR"
                    aria-label="Cerrar consulta"
                    @click="$store.dispatch('setToggle', false), $router.push('/consultas')"
                    size="is-small" 
                    icon-pack="fas"
                    :icon-right="toggle ? 'chevron-right' : 'chevron-left'"
                />
                <Ticket/>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import Tickets from '@/components/Tickets.vue';
    import Ticket from '@/components/Ticket.vue';
    export default {
        name: 'TicketsPage',
        components:{
            Tickets,
            Ticket
        },
        methods:{
            ...mapActions(['setToggle'])
        },
        watch:{
            mapToggle(){
                if(this.toggle == false)
                    this.$route.go(-1);
            }
        },
        computed:{
            ...mapState(['toggle']),
            hasTicketId(){
                return Boolean(this.$route.params.id);
            }
        },
        created(){
            this.$store.dispatch('setToggle', this.hasTicketId);
        }
        
    }
</script>

<style lang="scss" scoped>
    #tickets-page{
        .columns{
            .column{
                &:last-child{
                    position: relative;
                    background-color: $white;
                    border-left: 6px solid $primary;
                    transition: all 400ms ease;
                    &:hover button{
                        opacity: 1!important;
                    }
                }
                .ticket-panel-toggle{
                    position: absolute;
                    left: -20px;
                    top: 40px;
                    z-index: 999;
                    opacity: 1;
                }
            }
    }

    @media (max-width: 768px) {
        position: relative;
        min-height: 100%;

        &.is-detail-open > .columns > .column:first-child.is-6-desktop {
            display: none;
        }

        &.is-detail-open > .columns > .column:last-child {
            position: fixed!important;
            inset: 54px 0 calc(64px + env(safe-area-inset-bottom)) 0;
            z-index: 1000;
            width: 100%;
            padding: 0;
            overflow-y: auto;
            background: $white;
            border-left: 0!important;
        }

        &:not(.is-detail-open) > .columns > .column:last-child {
            display: none;
        }

        .ticket-panel-toggle {
            position: fixed!important;
            top: 65px!important;
            right: 12px;
            left: auto!important;
            z-index: 1100!important;
        }
    }
}
</style>
